import { systemAdminActions } from 'admin/redux/slices/systemSlice';
import { store } from 'admin/redux/store';

/**
 * [管理者画面]処理の前後でloadingを走らせるラッパー関数
 */
export const loadWrapperFunc = async <T = void>(func: () => T) => {
  store.dispatch(systemAdminActions.loading(true));
  await func();
  store.dispatch(systemAdminActions.loading(false));
};

export default loadWrapperFunc;
